<script>
import storageService from "@/services/storage.service";
import Layout from "../../layouts/main";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import axios from "axios";
import statusOptionsMixin from "@/mixins/statusOptions";
import base_domain from "../../myvars";
import ImageUploadField from "@/components/shared/ImageUploadField.vue";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";
import { formatDate } from "@/helpers/dateFormatter";

export default {
  name: "StaffProfile",
  mixins: [statusOptionsMixin],
  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    ImageUploadField,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  data() {
    return {
      verifyes: storageService.getItem("userType") === "verification officer",
      Email: null,
      first_name: null,
      last_name: null,
      status: null,
      branch: null,
      applicantNum: [],
      assignPrsn: [],
      dateLog: [],
      statusLog: [],
      addStaff: false,
      total_approved: 0,
      total_reject: 0,
      total_incomplete: 0,
      signatureFile: null,
      stampFile: null,
      profilePic: null,
      pp: null,
      savedSignature: null,
      savedStamp: null,
      searchValueTable: "",
      selectFilterSort: null,
      headers: [
        { text: "Applicant Number", value: "applicantNum" },
        { text: "Assign", value: "assignPrsn" },
        { text: "Date", value: "dateLog" },
        { text: "Status", value: "statusLog" },
      ],
      items: [],
      arrItem: [],

      // presentation only: skeletons + client-side paging for the footer
      loading: true,
      page: 1,
      rowsPerPage: 10,
    };
  },
  computed: {
    fullName() {
      return `${this.first_name || ""} ${this.last_name || ""}`.trim() || "N/A";
    },
    statusSelectOptions() {
      return [
        { value: null, label: "All Status" },
        ...this.statusFilterOptions.map((o) => ({ value: o.key, label: o.label })),
      ];
    },
    pagedItems() {
      const start = (this.page - 1) * this.rowsPerPage;
      return this.arrItem.slice(start, start + this.rowsPerPage);
    },
  },
  created() {
    this.get_staff_data();
    this.filterStatus();
  },
  methods: {
    formatDate,
    staffTone(status) {
      return { Active: "green", Inactive: "blue" }[status] || "red";
    },
    onPageChange(page) {
      this.page = page;
    },
    onRowsChange(rowsPerPage) {
      this.rowsPerPage = rowsPerPage;
      this.page = 1;
    },
    // turns a server path into an absolute URL (null when empty)
    resolveMedia(raw) {
      if (!raw) return null;
      const value = String(raw);
      if (/^(https?:|data:)/.test(value)) return value;
      const base = (base_domain || "").replace(/\/+$/, "");
      return `${base}${value.startsWith("/") ? value : `/${value}`}`;
    },
    // drop anything chosen but not saved
    resetPending() {
      this.profilePic = null;
      this.signatureFile = null;
      this.stampFile = null;
    },
    closeModal() {
      this.addStaff = false;
      this.resetPending();
    },
    submitModal() {
      this.updateprofile();
      this.addStaff = false;
    },
    updateprofile() {
      const token = storageService.getItem("accessToken");
      axios
        .post("/applications/update_profile/", {
          token: token,
          f_name: this.first_name,
          l_name: this.last_name,
          profile_pic: this.profilePic,
          signature: this.signatureFile,
          stamp: this.stampFile,
        })
        .then(() => {
          this.addStaff = false;
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    filterStatus() {
      if (!this.selectFilterSort || this.selectFilterSort === "all") {
        this.arrItem = [...(this.items || [])];
      } else {
        // strict match on the backend status key
        this.arrItem = (this.items || []).filter(
          (item) => item.statusLog === this.selectFilterSort,
        );
      }
      this.page = 1;
    },
    get_staff_data() {
      let arrList = [];
      const app_id = storageService.getItem("accessToken");

      axios
        .post("/applications/single_user_details/", { app_id: app_id })
        .then((response) => {
          const data = response.data.user_email;
          ((this.first_name = data.first_name),
            (this.last_name = data.last_name),
            (this.status = data.staff_status));
          this.Email = data.email;
          this.branch = data.branch_name;
          this.total_approved = Number(response.data.approved_status) || 0;
          this.total_reject = Number(response.data.rejected_status) || 0;
          this.pp = this.resolveMedia(data.pro_image);
          this.savedSignature = this.resolveMedia(data.signature);
          this.savedStamp = this.resolveMedia(data.stamp);
          let responseList = response.data.user_datw;
          responseList.forEach((item) => {
            let newItem = {
              applicantNum: item.application_no || `ECU-${String(item.id).padStart(6, "0")}`,
              assignPrsn: `${data.first_name || ""} ${data.last_name || ""}`.trim() || data.username,
              dateLog: item.created_on,
              statusLog: item.status,
            };
            // Push the transformed item to the existing array
            arrList.push(newItem);
          });
          this.items = arrList;
          this.filterStatus();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="sprof">
      <header class="ecu-page-head">
        <div>
          <h1>My Profile</h1>
          <p class="ecu-page-head__sub">Your details and the applications assigned to you.</p>
        </div>
        <router-link to="/staff_dashboard" class="ecu-text-link">
          <AppIcon name="chevron-left" :size="16" :stroke="2.2" />
          Dashboard
        </router-link>
      </header>

      <div class="ecu-detail">
        <!-- profile -->
        <aside class="ecu-card">
          <div class="ecu-profile">
            <span class="ecu-profile__avatar">
              <img
                :src="pp === null ? require('@/assets/images/staff.png') : pp"
                alt="Profile picture"
              />
            </span>
            <h2 class="ecu-profile__name">
              <span v-if="loading" class="ecu-skeleton ecu-info__sk" aria-hidden="true"></span>
              <template v-else>{{ fullName }}</template>
            </h2>
            <span class="ecu-profile__role">Staff Member</span>
            <span v-if="verifyes" class="ecu-profile__role ecu-profile__role--alt">
              Verification Officer
            </span>

            <a
              href="javascript:void(0);"
              class="ecu-btn-add sprof__edit"
              @click="addStaff = true"
            >
              <AppIcon name="edit" :size="16" />
              Edit Profile
            </a>
          </div>

          <div class="ecu-stat-pair">
            <div class="ecu-stat-pair__item">
              <span class="ecu-stat-pair__icon ecu-stat-pair__icon--ok">
                <AppIcon name="check-circle" :size="20" />
              </span>
              <span>
                <strong>{{ total_approved }}</strong>
                <small>Approved</small>
              </span>
            </div>
            <div class="ecu-stat-pair__item">
              <span class="ecu-stat-pair__icon ecu-stat-pair__icon--bad">
                <AppIcon name="x-circle" :size="20" />
              </span>
              <span>
                <strong>{{ total_reject }}</strong>
                <small>Rejected</small>
              </span>
            </div>
          </div>

          <ul class="ecu-info">
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="mail" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Email</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ Email || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="user" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">First Name</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ first_name || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="user" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Last Name</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ last_name || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="shield-check" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Status</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <StatusChip
                    v-else-if="status"
                    :label="`${status}`"
                    :tone="staffTone(`${status}`)"
                  />
                  <template v-else>N/A</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="bank" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Branch</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ branch || "N/A" }}</template>
                </span>
              </span>
            </li>
          </ul>
        </aside>

        <!-- related applications -->
        <div class="ecu-card">
          <div class="ecu-toolbar ecu-toolbar--related">
            <div class="ecu-card__head">
              <span class="ecu-tile">
                <AppIcon name="file" :size="20" />
              </span>

              <h2 class="ecu-card__title">Related Applications</h2>

              <div class="ecu-toolbar__row">
                <EcuSelect
                  v-model="selectFilterSort"
                  class="ecu-filter-select"
                  :options="statusSelectOptions"
                  aria-label="Filter by status"
                  @change="filterStatus"
                />
              </div>
            </div>
          </div>

          <div class="ecu-table-wrap">
            <EasyDataTable
              header-text-direction="center"
              :headers="headers"
              :items="pagedItems"
              :search-value="searchValueTable"
              :loading="loading"
              :rows-per-page="rowsPerPage"
              empty-message="No related applications found"
              theme-color="#f97316"
              hide-footer
              table-class-name="table-custom-style noWrapHeading"
            >
              <template #item-applicantNum="{ applicantNum }">
                <span class="ecu-strong">{{ applicantNum }}</span>
              </template>
              <template #item-dateLog="{ dateLog }">
                <span class="ecu-date">
                  <AppIcon name="calendar" :size="16" />
                  {{ formatDate(dateLog) }}
                </span>
              </template>
              <template #item-statusLog="{ statusLog }">
                <StatusChip :status="statusLog" />
              </template>
            </EasyDataTable>
          </div>

          <TableFooter
            :page="page"
            :rows-per-page="rowsPerPage"
            :total="arrItem.length"
            :loading="loading"
            @update:page="onPageChange"
            @update:rowsPerPage="onRowsChange"
          />
        </div>
      </div>

      <!-- edit profile modal -->
      <b-modal
        title="Update Profile Info"
        v-model="addStaff"
        hide-footer
        centered
        @hidden="resetPending"
      >
        <form class="ecu-m-form" @submit.prevent="submitModal">
          <div class="ecu-m-grid">
            <div class="ecu-m-field ecu-m-field--wide">
              <label class="ecu-m-label">Email</label>
              <input
                v-model="Email"
                type="email"
                class="ecu-m-input"
                placeholder="Email"
                disabled
              />
            </div>
            <div class="ecu-m-field">
              <label class="ecu-m-label">First Name</label>
              <input
                v-model="first_name"
                type="text"
                class="ecu-m-input"
                placeholder="First Name"
              />
            </div>
            <div class="ecu-m-field">
              <label class="ecu-m-label">Last Name</label>
              <input
                v-model="last_name"
                type="text"
                class="ecu-m-input"
                placeholder="Last Name"
              />
            </div>
            <div class="ecu-m-field ecu-m-field--wide">
              <label class="ecu-m-label">Profile Picture</label>
              <ImageUploadField v-model="profilePic" label="Profile picture" :saved-url="pp" />
            </div>
            <div class="ecu-m-field ecu-m-field--wide">
              <label class="ecu-m-label">Signature</label>
              <ImageUploadField v-model="signatureFile" label="Signature" :saved-url="savedSignature" />
            </div>
            <div class="ecu-m-field ecu-m-field--wide">
              <label class="ecu-m-label">Stamp</label>
              <ImageUploadField v-model="stampFile" label="Stamp" :saved-url="savedStamp" />
            </div>
          </div>
          <div class="ecu-m-actions">
            <button type="button" class="ecu-m-btn ecu-m-btn--ghost" @click="closeModal">
              Cancel
            </button>
            <button type="submit" class="ecu-m-btn">Update</button>
          </div>
        </form>
      </b-modal>
    </section>
  </Layout>
</template>

<style scoped>
/* Related Applications Header */
.sprof .ecu-toolbar--related {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: block;
}

.sprof .ecu-toolbar--related .ecu-card__head {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 12px;
  margin: 0;
}

/* Icon */
.sprof .ecu-toolbar--related .ecu-tile {
  flex: 0 0 28px;
  width: 28px;
  margin: 0;
}

/* Title */
.sprof .ecu-toolbar--related .ecu-card__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  line-height: 1.25;
}

/* Dropdown wrapper */
.sprof .ecu-toolbar--related .ecu-toolbar__row {
  flex: 0 1 185px;
  width: 185px;
  min-width: 0;
  max-width: 185px;
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
}

/* Dropdown */
.sprof .ecu-toolbar--related .ecu-filter-select {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

/* Mobile */
@media (max-width: 480px) {
  .sprof .ecu-toolbar--related .ecu-card__head {
    gap: 8px;
  }

  .sprof .ecu-toolbar--related .ecu-toolbar__row {
    flex-basis: 125px;
    max-width: 125px;
  }
}
</style>